function sumTotal(num1, num2 = 0, num3 = 0) {
  let someTotal = num1 + num2 + num3
  return someTotal
}

export { sumTotal }
